import React from "react";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ImagePreviewDialog = ({ openImage, onClose }) => {
  return (
    <Dialog
      open={!!openImage}
      onClose={onClose}
      maxWidth="md"
      PaperProps={{
        sx: {
          backgroundColor: "black",
          borderRadius: 2,
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          color: "white",
          background: "rgba(0,0,0,0.4)",
          "&:hover": { background: "rgba(0,0,0,0.6)" },
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ p: 0 }}>
        {openImage && (
          <img
            src={openImage}
            alt="Preview"
            style={{
              width: "100%",
              height: "auto",
              maxHeight: "90vh",
              display: "block",
              margin: "0 auto",
              objectFit: "contain",
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ImagePreviewDialog;
